import React, { useCallback, useEffect, useState } from "react";
import { useMutation } from "urql";
import { createProduct3DModel } from "api/mutations";
import { useResizeDetector } from "react-resize-detector";
import {
  useProductsOverviewStore,
  useProductsOverviewActions,
} from "stores/productsOverviewStore";
import { useTranslate } from "hooks";

const Product3DModel = ({ requestParams, fixedHeight = false }) => {
  const [, execute] = useMutation(createProduct3DModel);
  const translate = useTranslate();
  const [iframeDoc, setIframeDoc] = useState("");
  const [height, setHeight] = useState(0);

  const { ref, width: detectedWidth } = useResizeDetector({
    onResize: ({ height: h }) => setHeight(h),
  });

  const waitingFor3dModel = useProductsOverviewStore(
    (state) => state.waitingFor3dModel,
  );
  const { setWaitingFor3dModel } = useProductsOverviewActions();

  useEffect(() => {
    if (!requestParams) {
      return;
    }
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIframeDoc("");
    requestParams &&
      execute(
        {
          input: {
            systemOfUnits: requestParams.resultUnitsSystem,
            languageIso2L:
              requestParams.languageCode || requestParams.languageIso2L,
            countryIso2L: "de",
            seriesId: requestParams.seriesId,
            state: requestParams.state,
          },
        },
        { context: { requestType: "3d-iframe" } },
      ).then(({ error: _error, data }) => {
        if (_error) {
          setWaitingFor3dModel && setWaitingFor3dModel("failed");
          setIframeDoc("");
          return;
        }
        if (data) {
          if (data.createProductXBIMReport?.base64Data) {
            setWaitingFor3dModel && setWaitingFor3dModel(false);
            const atobw = atob(data.createProductXBIMReport?.base64Data);
            setIframeDoc(atobw);
          } else {
            setWaitingFor3dModel && setWaitingFor3dModel("failed");
            setIframeDoc("");
          }
        }
      });
  }, [requestParams, execute, setIframeDoc, setWaitingFor3dModel]);

  const sendXmlByForm = useCallback(() => {
    const binaryString = iframeDoc;
    const byteArray = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i);
    }
    const decoder = new TextDecoder("utf-8");
    const xmlString = decoder.decode(byteArray);
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "application/xml");
    const serializedXml = new XMLSerializer().serializeToString(xmlDoc);

    document.getElementById("xmlString").value = serializedXml;

    const submitForm = () => {
      const form = document.getElementById("view_3d_form");
      HTMLFormElement.prototype.submit.call(form);
    };

    submitForm();
  }, [iframeDoc]);

  useEffect(() => {
    if (iframeDoc) {
      sendXmlByForm();
    }
  }, [iframeDoc, sendXmlByForm]);

  const width = (height || 0) * 2;

  return (
    <div
      className="w-100 h-100 d-flex justify-content-center align-items-center"
      ref={ref}
    >
      <div
        style={{
          width: fixedHeight ? width : "100%",
          height: !fixedHeight && detectedWidth ? detectedWidth / 2 : "100%",
        }}
      >
        <form
          name="view_3d_form"
          id="view_3d_form"
          action="https://linear-cad-portal.herokuapp.com/pages/productLight"
          encType="multipart/form-data"
          method="post"
          target="vid_iframe"
          className="view3d_form"
        >
          <div>
            <textarea id="xmlString" name="xmlString" hidden defaultValue="" />
          </div>
          <div>
            <input
              type="hidden"
              id="language"
              name="language"
              defaultValue={requestParams.languageIso2L || "de"}
            />
          </div>
          <div>
            <input
              type="hidden"
              name="showXmlDescription"
              defaultValue="false"
            />
          </div>
          <div>
            <input type="hidden" name="vendorStyle" defaultValue="trox" />
          </div>
          <div>
            <button
              type="submit"
              id="view3dFormSubmit"
              name="submit"
              hidden
            ></button>
          </div>
        </form>

        {waitingFor3dModel === "failed" ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <p>{translate("PRODUCT_IFRAME_EMPTY")} </p>
          </div>
        ) : (
          iframeDoc !== "" && (
            <iframe
              title="3d-view"
              name="vid_iframe"
              id="vid_iframe"
              className="d-flex mt-2 w-100 h-100"
            />
          )
        )}
      </div>
    </div>
  );
};

export default Product3DModel;
